import { createLucideIcon } from 'lucide-react';
export const QRCodeSolidIcon = createLucideIcon('qr-code-solid-icon', [
  [
    'path',
    {
      d: 'M12 16V16.01',
      key: 'tp8sa5',
    },
  ],
  [
    'path',
    {
      d: 'M12 21V20',
      key: 'xb6air',
    },
  ],
  [
    'path',
    {
      d: 'M12 3H12.01',
      key: '1pfz6x',
    },
  ],
  [
    'path',
    {
      d: 'M12 7V10C12 10.5304 11.7893 11.0391 11.4142 11.4142C11.0391 11.7893 10.5304 12 10 12H7',
      key: '1p0iem',
    },
  ],
  [
    'path',
    {
      d: 'M16 12H17',
      key: 'r3jxlp',
    },
  ],
  [
    'path',
    {
      d: 'M20 3H17C16.4477 3 16 3.44772 16 4V7C16 7.55228 16.4477 8 17 8H20C20.5523 8 21 7.55228 21 7V4C21 3.44772 20.5523 3 20 3Z',
      key: '121jdw',
    },
  ],
  [
    'path',
    {
      d: 'M21 12V12.01',
      key: '1k03y8',
    },
  ],
  [
    'path',
    {
      d: 'M21 16H18C17.4696 16 16.9609 16.2107 16.5858 16.5858C16.2107 16.9609 16 17.4696 16 18V21',
      key: 'wg8pjd',
    },
  ],
  [
    'path',
    {
      d: 'M21 21V21.01',
      key: 'kkutcd',
    },
  ],
  [
    'path',
    {
      d: 'M3 12H3.01',
      key: '1oig12',
    },
  ],
  [
    'path',
    {
      d: 'M7 16H4C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H7C7.55228 21 8 20.5523 8 20V17C8 16.4477 7.55228 16 7 16Z',
      key: 'df3xwy',
    },
  ],
  [
    'path',
    {
      d: 'M7 3H4C3.44772 3 3 3.44772 3 4V7C3 7.55228 3.44772 8 4 8H7C7.55228 8 8 7.55228 8 7V4C8 3.44772 7.55228 3 7 3Z',
      key: '1nr7cu',
    },
  ],
]);
